// @flow
import * as React from 'react'

import { IconArrowBigLeft, Link, Navigation } from '@toggl/ui'

export function Product() {
  return (
    <Navigation.DropdownItem item="product">
      <span>Product</span>
      <React.Fragment>
        <Navigation.DropdownColumn title="For every need">
          <Navigation.LinkWithIcon
            link="/track/features/"
            imageLink={require('components/layouts/assets/icon-features.svg')}
            imageAlt="Icon: 4 squares aligned slantedly"
            title="Key features"
            description="View features by need, from time tracking to project and team management"
          />

          <Navigation.LinkWithIcon
            link="/track/employee-time-tracking/"
            imageLink={require('components/layouts/assets/icon-employee.svg')}
            imageAlt="Icon: A face with a smile and pink hair"
            title="Employee time tracking"
            description="Loved by teams and team leads. Error-free timesheet data and ease of use"
          />

          <Navigation.LinkWithIcon
            link="/track/time-tracking-invoicing/"
            imageLink={require('components/layouts/assets/icon-billing.svg')}
            imageAlt="Icon: A hand holding a coin"
            title="Billing and invoicing"
            description="Capture every billable minute so you can invoice with ease and precision"
          />

          <Navigation.LinkWithIcon
            link="/track/payroll-hours-tracker/"
            imageLink={require('components/layouts/assets/icon-payroll.svg')}
            imageAlt="Icon: A calendar with a face"
            title="Payroll"
            description="Calculate payroll for contractors and employees based on accurate data"
          />

          <Navigation.LinkWithIcon
            link="/track/online-time-reporting/"
            imageLink={require('components/layouts/assets/icon-reporting.svg')}
            imageAlt="Icon: A pie chart"
            title="Reporting and transparency"
            description="Get a big picture overview or dig into details with insightful reports"
          />

          <Navigation.LinkWithIcon
            link="/track/project-time-tracking/"
            imageLink={require('components/layouts/assets/icon-project.svg')}
            imageAlt="Icon: An archery target with a tick at the bullseye"
            title="Project budgeting"
            description="Stay on track with budgets and deadlines. Eliminate scope creep and overwork"
          />

          <Link.Long to="/track/antisurveillance-statement/">
            Toggl Track stands against employee surveillance. Read our statement
            here.
            <IconArrowBigLeft />
          </Link.Long>
        </Navigation.DropdownColumn>

        <Navigation.DropdownSideColumn title="Track anywhere you like">
          <Navigation.LinkWithIcon
            link="/track/signup/"
            imageLink={require('components/layouts/assets/icon-webapp.svg')}
            imageAlt="Icon: Magnifying glass zoning in on a lightning bolt"
            title="Web app"
            description="Full-suite app for time, project and team management"
          />

          <Navigation.LinkWithIcon
            link="/track/mobile-time-tracking-app/"
            imageLink={require('components/layouts/assets/icon-mobile.svg')}
            imageAlt="Icon: A crown with Toggl's icon on it"
            title="Mobile apps"
            description="Time tracking on the go with our iOS and Android apps"
          />

          <Navigation.LinkWithIcon
            link="/track/toggl-desktop/"
            imageLink={require('components/layouts/assets/icon-desktop.svg')}
            imageAlt="Icon: Magnifying glass zoning in on a lightning bolt"
            title="Desktop apps"
            description="Launch right from your Windows, Mac, or Linux machine"
          />

          <Navigation.LinkWithIcon
            link="/track/integrations/"
            imageLink={require('components/layouts/assets/icon-integration.svg')}
            imageAlt="Icon: A hand clicking on a button in a web browser interface"
            title="100+ integrations"
            description="Explore our native integrations or track time via browser extensions"
          />
        </Navigation.DropdownSideColumn>
      </React.Fragment>
    </Navigation.DropdownItem>
  )
}
